import { faFile } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { ReactComponent as ManIcon } from "../../assets/icons/accessibility-man-icon.svg";
import { ReactComponent as BlackWhite } from "../../assets/icons/black-and-white.svg";
import { ReactComponent as DecreaseFont } from "../../assets/icons/decrease-font-size.svg";
import { ReactComponent as ImageHiding } from "../../assets/icons/hide-images.svg";
import { ReactComponent as LinkHighlighting } from "../../assets/icons/highlight-links.svg";
import { ReactComponent as IncreaseFont } from "../../assets/icons/increase-font-size.svg";
import { ReactComponent as InvertColors } from "../../assets/icons/invert-colours.svg";
import { ReactComponent as NegativeContrast } from "../../assets/icons/negative-contrast.svg";
import { ReactComponent as FontReset } from "../../assets/icons/reset-font.svg";
import ModalWindow from "../common/Modal/Modal";
import "./Accessibility.css";
import { useAccessibility } from "./AccessibilityContext";

const Accessibility = () => {
  const {
    setFontSize,
    setFilterBW,
    setInvert,
    setNegative,
    setLinkHighlight,
    setHideImages,
    getAccessibilityClasses,
  } = useAccessibility();
  const [btnCounter, setBtnCounter] = useState(0);
  const [modalShow, setModalShow] = useState(false);

  const displayMenu = () => {
    setBtnCounter((prevState) => prevState + 1);
  };
  const displayDeclaration = () => {
    setModalShow((prevState) => !prevState);
  };
  const increaseFontSize = () => {
    setFontSize((prevState) => {
      let nextValue = prevState + 3;
      if (nextValue >= 50) nextValue = 50;
      return nextValue;
    });
  };
  const decreaseFontSize = () => {
    setFontSize((prevState) => {
      let nextValue = prevState - 3;
      if (nextValue <= 5) nextValue = 5;
      return nextValue;
    });
  };
  const resetFontSize = () => {
    setFontSize(() => 16);
  };
  const setBlackWhite = () => {
    setFilterBW((prevState) => !prevState);
  };
  const invertColors = () => {
    setInvert((prevState) => !prevState);
  };
  const negativeContrast = () => {
    setNegative((prevState) => !prevState);
  };
  const linkHighlighting = () => {
    setLinkHighlight((prevState) => !prevState);
  };
  const imageHiding = () => {
    setHideImages((prevState) => !prevState);
  };
  const getModalBody = () => {
    return (
      <div>
        <p>
          La NN ne asigurăm că produsele și serviciile noastre sunt accesibile
          pentru toate persoanele.
        </p>
        <p>
          Informațiile sunt disponibile în formate accesibile, folosim structuri
          clare pentru conținut şi evităm folosirea unor termeni de specialitate
          sau complecşi.
        </p>
        <p>
          Navigarea și utilizarea sunt ușoare, utilizăm caractere adecvate,
          ținând cont de condițiile de utilizare previzibile. Poţi mări
          dimensiunea textului pentru o vizibilitate mai bună, poţi schimba
          culorile în alb și negru pentru un contrast mai mare sau poţi inversa
          culorile. Link-urile sunt evidențiate pentru a fi mai vizibile și ușor
          de identificat.
        </p>
        <p>
          Paginile nu conțin elemente animate care ar putea conduce la
          declanșarea unor crize convulsive în cazul persoanelor fotosensibile,
          iar imaginile pot fi ascunse.
        </p>
        <p>
          Pentru acoperirea oricăror nevoi specifice, poţi accesa, alternativ,
          serviciul de Call Center.
        </p>
      </div>
    );
  };

  return (
    <div id="accessibility">
      <button
        className={`accessibility-btn 
          ${btnCounter !== 0 && btnCounter % 2 === 1 ? "move-left-btn" : btnCounter !== 0 && btnCounter % 2 === 0 ? "move-right-btn" : ""}
            ${getAccessibilityClasses()}`}
        type="button"
        onClick={displayMenu}
      >
        <ManIcon className="manicon" />
      </button>
      <div
        className={`widget-wrapper 
          ${btnCounter !== 0 && btnCounter % 2 === 1 ? "move-left-wgt" : ""} 
          ${getAccessibilityClasses()}`}
      >
        <p className="title-widget">Accesibilitate</p>
        <button
          className="accessibility-statement-btn"
          type="button"
          onClick={displayDeclaration}
        >
          <FontAwesomeIcon icon={faFile} size="xs" />
          <span>Declarație de accesibilitate</span>
        </button>
        <ul className="widget-grid">
          <li>
            <a onClick={increaseFontSize}>
              <IncreaseFont className="icon" />
              <span>
                Mărește
                <br />
                fontul
              </span>
            </a>
          </li>
          <li>
            <a onClick={decreaseFontSize}>
              <DecreaseFont className="icon" />
              <span>
                Micșorează
                <br />
                fontul
              </span>
            </a>
          </li>
          <li>
            <a onClick={setBlackWhite}>
              <BlackWhite className="icon" />
              <span>
                Alb și
                <br />
                negru
              </span>
            </a>
          </li>
          <li>
            <a onClick={invertColors}>
              <InvertColors className="icon" />
              <span>
                Inversează
                <br />
                culorile
              </span>
            </a>
          </li>
          <li>
            <a onClick={negativeContrast}>
              <NegativeContrast className="icon" />
              <span>
                Contrast
                <br />
                negativ
              </span>
            </a>
          </li>
          <li>
            <a onClick={linkHighlighting}>
              <LinkHighlighting className="icon" />
              <span>
                Evidențiază
                <br />
                legăturile
              </span>
            </a>
          </li>
          <li>
            <a onClick={resetFontSize}>
              <FontReset className="icon" />
              <span>
                Resetează
                <br />
                fontul
              </span>
            </a>
          </li>
          <li>
            <a onClick={imageHiding}>
              <ImageHiding className="icon" />
              <span>
                Ascunde
                <br />
                imaginile
              </span>
            </a>
          </li>
        </ul>
      </div>
      <ModalWindow
        className={getAccessibilityClasses()}
        show={modalShow}
        onHide={() => setModalShow(false)}
        heading="Declarație de accesibilitate"
        body={getModalBody()}
        closeText="Închide"
      />
    </div>
  );
};

export default Accessibility;
